import React, { useState } from "react";
import moment from "moment";
import { toCommas } from "../../utils/utils";
import styles from "./InvoiceDetails.module.css";
import { Box, Button, Modal, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  payChecksAction,
  updateChecksAction,
} from "../../actions/checkActions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PaymentHistory = ({ paymentRecords, setPaymentId, setOpenPayment }) => {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("profile"));

  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [note, setNote] = useState("");
  const handleOpen = (note) => {
    setNote(note);
    setOpen(true);
  };
  const handlePayeCheck = (paymentId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to process this payment?"
    );

    if (isConfirmed) {
      dispatch(
        payChecksAction({
          paymentId,
          datePaid: new Date(),
          paidBy: user?.result?.name,
          invoiceId: id,
        })
      );
    }
  };

  const handleUpdateCheck = (paymentId) => {
    dispatch(
      updateChecksAction({
        paymentId,
        datePaid: new Date(),
        paidBy: user?.result?.name,
        invoiceId: id,
      })
    );
  };

  const handleClose = () => setOpen(false);

  return (
    <div className="tabs">
      <div className="tab">
        <input type="checkbox" id="chck1" />
        <label className="tab-label" htmlFor="chck1">
          Payment History{" "}
          <span className={styles.totalUnpaid}>{paymentRecords?.length}</span>
          <span className={styles.space}></span>
        </label>
        <div className="tab-content">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>Date Paid</th>
                  <th>Amount Paid</th>
                  <th>Payment Method</th>
                  <th>Paid by</th>
                  <th>Guaranteed</th>
                  <th>Paid</th>
                  <th>Delivery ID</th>
                  <th>Note</th>
                </tr>
                {paymentRecords?.map((record) => (
                  <tr
                    key={record._id}
                    onClick={() => {
                      if (user?.result?.role == "admin") {
                        setPaymentId(record._id);
                        setOpenPayment(true);
                      }
                    }}
                  >
                    <td>{moment(record.datePaid).format("MMMM Do YYYY")}</td>
                    <td>{toCommas(record.amountPaid)}</td>
                    <td>{record.paymentMethod}</td>
                    <td>{record.paidBy}</td>
                    <td>
                      {record.guaranteed ? (
                        <Button
                          style={{ color: "blue" }}
                          onClick={() => handleUpdateCheck(record._id)}
                        >
                          Yes
                        </Button>
                      ) : (
                        <Button style={{ color: "blue" }}>No</Button>
                      )}
                    </td>
                    <td>
                      {" "}
                      {record?.check?.returned === false &&
                      record.check?.guaranteed ? (
                        <Button
                          style={{ color: "red", marginLeft: "-10px" }}
                          onClick={() => handlePayeCheck(record._id)}
                        >
                          Unpaid
                        </Button>
                      ) : (
                        <Button style={{ color: "green", marginLeft: "-10px" }}>
                          Paid
                        </Button>
                      )}
                    </td>
                    <td>
                      {record?.check?.delivered
                        ? record?.check?.delivered
                        : "Not delivered"}
                    </td>
                    {record.note ? (
                      <td>
                        <Button
                          style={{ color: "blue" }}
                          onClick={() => handleOpen(record.note)}
                        >
                          note
                        </Button>
                      </td>
                    ) : (
                      <td>No note</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {note}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default PaymentHistory;
